/**
 * Validates an email address.
 *
 * @param {string} val - The email address to be validated
 * @return {string} The error message, if any
 */
export const validateEmail = (val) => {
  let err = "";
  if (!val) {
    err = "Email is Required";
  } else if (!/^[A-Z0-9._%+-]+@[letA-Z0-9.-]+\.[A-Z]{2,}$/i.test(val)) {
    err = "Invalid email address";
  }

  return err;
};
/**
 * Validates the password based on the given format requirements.
 *
 * @param {string} val - the password to be validated
 * @param {object} format - an object containing format requirements for the password
 * @return {string} an error message, if any, based on the validation rules
 */
export const validatePassword = (val, format = {}) => {
  let err = "";
  if (!val) {
    err = `Password is Required`;
  } else if (format.min && val.length < format.min) {
    err = `Password must be at least ${format.min} characters`;
  } else if (format.max && val.length > format.max) {
    err = `Password must be at most ${format.max} characters`;
  } else if (format.upperCase && !/[A-Z]/.test(val)) {
    err = `Password must contain at least one uppercase letter`;
  } else if (format.lowerCase && !/[a-z]/.test(val)) {
    err = `Password must contain at least one lowercase letter`;
  } else if (format.number && !/[0-9]/.test(val)) {
    err = `Password must contain at least one number`;
  } else if (format.special && !/[!@#$%^&*(),.?":{}|<>]/.test(val)) {
    err = `Password must contain at least one special character`;
  }
  return err;
};

/**
 * Validates the verification code and returns an error message if the code is missing.
 *
 * @param {any} val - the verification code to be validated
 * @return {string} an error message if the code is missing
 */
export const validateVerifyCode = (val) => {
  let err = "";
  if (!val) {
    err = "Verification Code is Required";
  }
  return err;
};

/**
 * Function to check if the password matches the confirm password.
 *
 * @param {any} val - the password to be checked
 * @param {any} match - the confirm password to be compared
 * @return {string} the error message if passwords do not match
 */
export const matchPassword = (val, match) => {
  let err = "";
  if (!val) {
    err = "Confirm Password is Required";
  } else if (val !== match) {
    err = "Password doesn't match";
  }
  return err;
};

export const validatePhoneNumber = (val) => {
  let err = "";
  if (!val) {
    err = "Phone Number is Required";
  } else if (
    !/^\(?(0|\+44)[1-9]{1}\d{1,4}?\)?\s?\d{3,4}\s?\d{3,4}$/.test(val)
  ) {
    err = "Invalid phone number";
  }

  return err;
};
